import React from "react";
import logo from "../assets/logo.png";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-greenLight flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* Logo Placeholder - Replace with your actual logo import/component */}
        <div className="mb-8 flex justify-center">
          <img src={logo} alt="Company Logo" className="h-16" />
        </div>

        <div className="text-6xl font-bold text-customgreen mb-4">404</div>

        <div className="h-1 w-24 bg-buttonhover mx-auto mb-6"></div>

        <p className="text-gray-700 mb-8 px-4">
          The page you are searching does not exist.
        </p>

        <button
          onClick={() => (window.location.href = "/")}
          className="
            px-6 py-3 
            bg-buttonhover
            text-white
            rounded-full
            hover:bg-buttonhover
            transition-colors
            shadow-md hover:shadow-lg
          "
        >
          Back to Home Page
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
